import { useEffect, useState } from 'react';

/**
 * Hook to detect if Developer Tools are open and restrict common inspection behaviors.
 * Works primarily by detecting window size differences and debugger pauses.
 */
export default function useDisableInspect() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Only enable protection in production mode
    if (import.meta.env.VITE_DEV_MODE) return;

    let devtoolsDetected = false;

    const detect = () => {
      devtoolsDetected = true;
      setIsOpen(true);
    };

    const debuggerCheck = () => {
      const start = performance.now();
      // eslint-disable-next-line no-debugger
      debugger;
      const end = performance.now();

      if (end - start > 100) {
        detect();
      }
    };

    // Detection via console.log of an object with a getter
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get() {
        detect();
        return ''; // satisfy getter-return rule
      },
    });

    const disableShortcuts = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && ['I', 'C', 'J'].includes(e.key)) ||
        (e.ctrlKey && e.key.toLowerCase() === 'u')
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const disableContextMenu = (e) => {
      e.preventDefault();
    };

    const interval = setInterval(() => {
      if (!devtoolsDetected) {
        debuggerCheck();
      }
    }, 1000);

    window.addEventListener('keydown', disableShortcuts, true);
    document.addEventListener('contextmenu', disableContextMenu);

    // Initial check

    return () => {
      clearInterval(interval);
      window.removeEventListener('keydown', disableShortcuts, true);
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, []);

  return isOpen;
}
